// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BXvJ","badges":"styles_badges__3d7Fy"};